import { store$ } from '@redux/store';
import { ResultType, selectResultsType } from 'features/searchResultsFacets';
import { distinctUntilChanged, filter, map } from 'rxjs';

const panelsElements = [
  document.querySelector('[data-typeahead-container]'),
  document.querySelector('[data-facets-panel]'),
];

/**
 * Hides all elements in the `panelsElements` array.
 * Adds the `hidden` attribute to make the elements invisible.
 */
const hidePanels = () => panelsElements.forEach((element) => element?.setAttribute('hidden', ''));

/**
 * Shows all elements in the `panelsElements` array.
 * Removes the `hidden` attribute to make the elements visible.
 */
const showPanels = () => panelsElements.forEach((element) => element?.removeAttribute('hidden'));

/**
 * Checks if the result type is `Builders`.
 *
 * @param {string} resultType - The current result type from the store.
 * @returns {boolean} - True if `resultType` equals `ResultType.Builders`.
 */
const isBuildersResultType = (resultType) => resultType === ResultType.Builders.toString();

/**
 * Checks if the result type is not `Builders`.
 *
 * @param {string} resultType - The current result type from the store.
 * @returns {boolean} - True if `resultType` does not equal `ResultType.Builders`.
 */
const isNotBuildersResultType = (resultType) => !isBuildersResultType(resultType);

/**
 * Observable stream that emits the current `ResultType` from the store whenever it changes.
 *
 * - `map(selectResultsType)`: Extracts the `ResultType` from the Redux store's state.
 * - `distinctUntilChanged()`: Emits only when the `ResultType` changes to a new value.
 */
const onResultTypeChange$ = store$.pipe(map(selectResultsType), distinctUntilChanged());

// Subscribes to the `onResultTypeChange$` stream and hides panels if the result type is `Builders`.
onResultTypeChange$.pipe(filter(isBuildersResultType)).subscribe(hidePanels);

// Subscribes to the `onResultTypeChange$` stream and shows panels if the result type is not `Builders`.
onResultTypeChange$.pipe(filter(isNotBuildersResultType)).subscribe(showPanels);
